import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import * as React from 'react';
import DatePicker from 'react-date-picker';
import { ClipLoader } from 'react-spinners';
import { useReactToPrint } from 'react-to-print';
import {
  H6,
  H2,
  PageWrapper,
  UpperPartWrap,
  UpperTittleWrap,
  SearchBarWrap,
  SearchBar,
  TableWrap,
  Table,
  Thead,
  Tr,
  Tableheader,
  Sortby,
  FilterByDateButton,
  FilterbySessionButton,
  DateDiv,
  Name,
  Session,
  Room,
  Signature,
  SearchIcon,
  ActiveSortOption,
  SearchSpan,
  DropdownWrap,
  SesssionDropdownWrap,
  SessionDropdownItem,
  Duration,
  SignatureImgWrap,
} from './styles';
import {
  GetSignaturesQuery,
  SearchAndFilterSignedRecordsMutation,
} from '../../../../../generated/graphql';
import { toast } from 'react-toastify';
import { AdminHomeLoader, NoData } from '../../../../../components';
import { FETCH_SIGNED_RECORDS, FILTER_AND_SEARCH_RECORDS } from './graphql';
import { academicYear } from '../../../../../helpers';
import { useExamsTypeAndSem } from '../../../../../helpers/examTypeAndSemester';

export const SignedInvigilatorRecords = (): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [currentRecords, setCurrentRecords] = React.useState<any>(null);
  const [showDateFilterOption, setShowDateFilterOption] = React.useState(false);
  const [showSessionFilterOption, setShowSessionFilterOption] = React.useState(false);
  const [sessionFilterValue, setSessionFilterValue] = React.useState(0);
  const [dateFromFilterValue, setDateFromFilterValue] = React.useState<Date | null>(null);
  const [dateToFilterValue, setDateToFilterValue] = React.useState<Date | null>(null);
  const [searchValue, setSearchValue] = React.useState('');
  const [showDropdown, setShowDropdown] = React.useState(false);
  const [searchOption, setSearchOption] = React.useState<'invigilator' | 'room' | ''>('');

  const [campusFilter, setCampusFilter] = React.useState<'Kumasi' | 'Obuasi' | 'ALL'>('ALL');
  const [showCampusFilterOption, setShowCampusFilterOption] = React.useState(false);

  const recordsRef = React.useRef(null);
  const { data, loading, error } = useQuery<GetSignaturesQuery>(FETCH_SIGNED_RECORDS);
  const [
    searchAndFilterSignedRecords,
    {
      data: filteredRecordsMutationData,
      loading: filteredRecordsMutationLoading,
      error: filteredRecordsMutationErr,
    },
     ] = useLazyQuery<SearchAndFilterSignedRecordsMutation>(FILTER_AND_SEARCH_RECORDS);
  const examTypeAndSemester = useExamsTypeAndSem();

  // ] = useMutation<SearchAndFilterSignedRecordsMutation>(FILTER_AND_SEARCH_RECORDS);
  // const examTypeAndSemester = useExamsTypeAndSem();

  const handlePrint = useReactToPrint({
    content: () => recordsRef.current,
    documentTitle: `${academicYear}-semester-${examTypeAndSemester?.semester}-
    ${examTypeAndSemester?.examType}-exams-${campusFilter}-invigilators-signatures`,
    pageStyle: '',
    onPrintError: () => toast.error('Printing of signed records failed!'),
  });

  // React.useEffect(() => {
  //   if (!dateFromFilterValue && !dateToFilterValue && !sessionFilterValue && !searchValue && campusFilter === 'ALL')
  //     setCurrentRecords(data?.getSignatures);
  //   if (filteredRecordsMutationData?.searchAndFilterSignedRecords) {
  //     setCurrentRecords(filteredRecordsMutationData?.searchAndFilterSignedRecords);
  //   } else {
  //     setCurrentRecords(data?.getSignatures);
  //   }
  //   console.log('=== FILTERED DATA ===');
  // console.log(filteredRecordsMutationData);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [data, filteredRecordsMutationData]);

  React.useEffect(() => {
  if (filteredRecordsMutationData?.searchAndFilterSignedRecords) {
    setCurrentRecords(filteredRecordsMutationData.searchAndFilterSignedRecords);
  } else if (campusFilter === 'ALL') {
    setCurrentRecords(data?.getSignatures);
  }
  }, [data, filteredRecordsMutationData, campusFilter]);

  if (loading) return <AdminHomeLoader />;

  const searchAndFilterSignedRecordsHandler = async (
    e?: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLElement>,
  ): Promise<void | React.ReactText> => {
    if (e) {
      e.preventDefault();
      if (!searchValue) return toast.warn('Provide some search value', { autoClose: 1200 });
    }

    // const variables= {
    //     searchValue: searchValue && searchValue,
    //     searchType: searchOption && searchOption,
    //     date: dateFromFilterValue &&
    //       dateFromFilterValue && { from: dateFromFilterValue, to: dateToFilterValue },
    //     session: sessionFilterValue && sessionFilterValue,
    //     campus: campusFilter !== 'ALL' ? campusFilter : undefined,
    //   }

    const variables = {
      ...(searchValue && { searchValue }),
      ...(searchOption && { searchType: searchOption }),
      ...(dateFromFilterValue && dateToFilterValue && {
        date: { from: dateFromFilterValue, to: dateToFilterValue },
      }),
      ...(sessionFilterValue && { session: sessionFilterValue }),
      ...(campusFilter !== 'ALL' && { campus: campusFilter }),
    };


  console.log('=== VARIABLES SENT ===');
  console.log(variables);
    await searchAndFilterSignedRecords({
      variables
    });
  };

  const renderPlaceholder = (): string => {
    if (searchOption === '') return 'Select search type first to enable form';
    else if (searchOption === 'room') return 'Search by room';
    else if (searchOption === 'invigilator') return 'Search by invigilator';
    else return 'Search';
  };

  const durationInHrAndMin = (time: number): string => {
    const durationInHr = time / 60;
    const durationInMin = time % 60;
    const hr = Math.floor(durationInHr);
    return `${hr} hr${hr > 1 ? 's' : ''} ${durationInMin > 0 ? `: ${durationInMin} mins` : ''}`;
  };

  const Sessions = [
    { name: '01', value: 1 },
    { name: '02', value: 2 },
    { name: '03', value: 3 },
    { name: '04', value: 4 },
    { name: '05', value: 5 },
    { name: '06', value: 6 },
    { name: '07', value: 7 },
    { name: '08', value: 8 },
  ];



  return (
    <PageWrapper>
      <UpperPartWrap>
        <UpperTittleWrap>
          <H6>Signed invigilator</H6>
          <H2>Records</H2>
        </UpperTittleWrap>
        <div className="flex items-center relative">
          <SearchBarWrap>
            <form onSubmit={searchAndFilterSignedRecordsHandler}>
              <SearchBar
                disabled={searchOption === ''}
                readOnly={searchOption === ''}
                placeholder={renderPlaceholder()}
                onChange={(e) => setSearchValue(e.target.value)}
                value={searchValue}
                className={searchOption === '' ? 'cursor-not-allowed' : 'cursor-text'}
              />
              <SearchIcon
                onClick={searchAndFilterSignedRecordsHandler}
                disabled={searchOption === ''}
                style={{ pointerEvents: searchOption === '' ? 'none' : 'auto' }}
                className="fas fa-search"
              />
            </form>
          </SearchBarWrap>
          <div
            onClick={() => setShowDropdown(!showDropdown)}
            className="border py-1 font-semibold px-2
             rounded-md ml-2 cursor-pointer select-none border-gray-300 bg-gray-100 text-center"
          >
            {searchOption === ''
              ? 'Search By'
              : searchOption.charAt(0).toUpperCase() + searchOption.slice(1)}
          </div>
          {showDropdown && (
            <DropdownWrap show={showDropdown}>
              <SearchSpan
                isActive={searchOption === 'room'}
                onClick={() => {
                  setSearchOption('room');
                  setSearchValue('');
                  setShowDropdown(!showDropdown);
                }}
              >
                Room
              </SearchSpan>
              <SearchSpan
                isActive={searchOption === 'invigilator'}
                onClick={async () => {
                  setSearchOption('invigilator');
                  setSearchValue('');
                  setShowDropdown(!showDropdown);
                }}
              >
                Invigilator
              </SearchSpan>
              <button
                onClick={() => {
                  setSearchValue('');
                  setSearchOption('');
                }}
                className="bg-[#eaeaea] mt-3 hover:text-green-600 text-[#05050580] font-semibold
               px-2 py-1 rounded-sm"
              >
                Clear
              </button>
              <button
                onClick={() => setShowDropdown(!showDropdown)}
                className="bg-[#eaeaea] -mb-2 hover:text-red-600 text-[#05050580] font-semibold
               px-2 py-1 rounded-sm"
              >
                Close
              </button>
            </DropdownWrap>
          )}
        </div>
      </UpperPartWrap>
      <TableWrap>
        <Tableheader>
          <Sortby>
            Filter by:{' '}
            <div className="flex items-center flex-col">
              <FilterByDateButton
                onClick={async () => {
                  setShowDateFilterOption(!showDateFilterOption);
                  setShowSessionFilterOption(false);
                }}
              >
                Date{' '}
              </FilterByDateButton>
              <ActiveSortOption isActive={showDateFilterOption} />
            </div>
            <div className="flex items-center flex-col">
              <FilterbySessionButton
                onClick={async () => {
                  setShowSessionFilterOption(!showSessionFilterOption);
                }}
              >
                Session
              </FilterbySessionButton>
              <ActiveSortOption isActive={showSessionFilterOption} />
            </div>
            <SesssionDropdownWrap show={showSessionFilterOption}>
              <div className="flex-1">
                {Sessions.slice(0, 4).map((session) => (
                  <SessionDropdownItem
                    key={session.value}
                    onClick={async () => {
                      setSessionFilterValue(session.value);
                      setShowSessionFilterOption(false);
                      await searchAndFilterSignedRecords({
                        variables: {
                          searchValue: searchValue && searchValue,
                          searchType: searchOption && searchOption,
                          date: dateFromFilterValue &&
                            dateFromFilterValue && {
                              from: dateFromFilterValue,
                              to: dateToFilterValue,
                            },
                          session: session.value,
                          campus: campusFilter !== 'ALL' ? campusFilter : undefined,
                        },
                      });
                    }}
                    isActive={sessionFilterValue === session.value}
                  >
                    {session.name}
                  </SessionDropdownItem>
                ))}
              </div>
              <div className="flex-1">
                {Sessions.slice(4, 10).map((session) => (
                  <SessionDropdownItem
                    key={session.value}
                    onClick={async () => {
                      setSessionFilterValue(session.value);
                      setShowSessionFilterOption(false);
                      await searchAndFilterSignedRecords({
                        variables: {
                          searchValue: searchValue && searchValue,
                          searchType: searchOption && searchOption,
                          date: dateFromFilterValue &&
                            dateFromFilterValue && {
                              from: dateFromFilterValue,
                              to: dateToFilterValue,
                            },
                          session: session.value,
                          campus: campusFilter !== 'ALL' ? campusFilter : undefined,
                        },
                      });
                    }}
                    isActive={sessionFilterValue === session.value}
                  >
                    {session.name}
                  </SessionDropdownItem>
                ))}
              </div>
              <div className="flex mt-1 bg-gray-50 justify-between">
                <button
                  className="bg-gray-100 px-3 py-2 text-xs font-bold"
                  onClick={async () => {
                    setSessionFilterValue(0);
                    setCurrentRecords(data?.getSignatures);
                  }}
                >
                  clear
                </button>
                <button
                  onClick={() => setShowSessionFilterOption(false)}
                  className="bg-gray-100 text-red-600 px-3 py-2 text-xs font-bold"
                >
                  close
                </button>
              </div>
            </SesssionDropdownWrap>
            <div className="flex items-center flex-col">
          <FilterbySessionButton
            onClick={() => {
              setShowCampusFilterOption(!showCampusFilterOption);
              setShowSessionFilterOption(false);
              setShowDateFilterOption(false);
            }}
          >
            Campus
          </FilterbySessionButton>
          <ActiveSortOption isActive={showCampusFilterOption} />
        </div>
        <SesssionDropdownWrap show={showCampusFilterOption}>
          <SessionDropdownItem
            isActive={campusFilter === 'Kumasi'}
            onClick={async () => {
              const selectedCampus = 'Kumasi';
              setCampusFilter(selectedCampus);
              setShowCampusFilterOption(false);

              await searchAndFilterSignedRecords({
                variables: {
                  searchValue: searchValue || undefined,
                  searchType: searchOption || undefined,
                  date: dateFromFilterValue && {
                    from: dateFromFilterValue,
                    to: dateToFilterValue,
                  },
                  // session: sessionFilterValue || undefined,
                  ...(sessionFilterValue > 0 && { session: sessionFilterValue }),
                  campus: selectedCampus,
                },
              });
            }}
          >
            Kumasi
          </SessionDropdownItem>

          <SessionDropdownItem
            isActive={campusFilter === 'Obuasi'}
            onClick={async () => {
            const selectedCampus = 'Obuasi';
            setCampusFilter(selectedCampus);
            setShowCampusFilterOption(false);

            await searchAndFilterSignedRecords({
              variables: {
                searchValue: searchValue || undefined,
                searchType: searchOption || undefined,
                date: dateFromFilterValue && {
                  from: dateFromFilterValue,
                  to: dateToFilterValue,
                },
                session: sessionFilterValue || undefined,
                campus: selectedCampus,
              },
            });
          }}
          >
            Obuasi
          </SessionDropdownItem>

          <SessionDropdownItem
            isActive={campusFilter === 'ALL'}
            onClick={() => {
              setCampusFilter('ALL');
              setCurrentRecords(data?.getSignatures);
              setShowCampusFilterOption(false);
            }}
          >
            All
          </SessionDropdownItem>
        </SesssionDropdownWrap>
          </Sortby>
          <button
            className="px-10 py-2 font-semibold hover:bg-blue-700
          bg-blue-600 text-white rounded-md"
            onClick={handlePrint}
          >
            Print records
          </button>
        </Tableheader>
        {showDateFilterOption && (
          <div className="mb-6 mt-2 flex gap-6">
            <div className="flex gap-1 items-center">
              <h3 className="text-sm 2xl:text-base font-semibold">From: </h3>
              <DatePicker
                format="dd/MM/y"
                onChange={setDateFromFilterValue}
                value={dateFromFilterValue}
                className="date-picker"
              />
            </div>
            <div className="flex gap-1 items-center">
              <h3 className="text-sm 2xl:text-base font-semibold">To: </h3>
              <DatePicker
                format="dd/MM/y"
                onChange={setDateToFilterValue}
                value={dateToFilterValue}
                className="date-picker"
              />
            </div>
            <button
              className="px-3 py-1 text-sm
               rounded-sm bg-blue-600 hover:bg-blue-800 font-semibold text-white"
              disabled={!dateFromFilterValue || !dateToFilterValue}
              style={{
                cursor: dateFromFilterValue && dateToFilterValue ? 'cursor' : 'not-allowed',
              }}
              onClick={async () => {
                await searchAndFilterSignedRecords({
                  variables: {
                    searchValue: searchValue && searchValue,
                    searchType: searchOption && searchOption,
                    date: dateFromFilterValue &&
                      dateFromFilterValue && { from: dateFromFilterValue, to: dateToFilterValue },
                    session: sessionFilterValue && sessionFilterValue,
                    campus: campusFilter !== 'ALL' ? campusFilter : undefined,
                  },
                });
              }}
            >
              Filter
            </button>
          </div>
        )}
        {error ||
        data?.getSignatures?.length === 0 ||
        (filteredRecordsMutationData?.searchAndFilterSignedRecords?.length === 0 &&
          searchValue !== '') ||
        (filteredRecordsMutationData?.searchAndFilterSignedRecords?.length === 0 &&
          sessionFilterValue !== 0) ||
        currentRecords?.length === 0 ||
        filteredRecordsMutationErr ? (
          <NoData title="Signed invigilator records was not found" />
        ) : (
          <Table ref={recordsRef}>
            <Thead>
              <DateDiv>Date</DateDiv>
              <Name>Name</Name>
              <Duration>Duration</Duration>
              <Session>Session</Session>
              <Room>Room</Room>
              <Signature>Signature</Signature>
            </Thead>
            {filteredRecordsMutationLoading ? (
              <div className="h-52 w-52 mx-auto flex justify-center flex-col items-center">
                <ClipLoader size={50} color="#000" />
                <h2 className="text-xl font-semibold mt-5">Loading...</h2>
              </div>
            ) : (
              <div
                className="flex-1 lg:h-[36rem] 2xl:h-[42rem] 2xl:pb-40 
              lg:pb-60 lg:overflow-auto"
              >
                {/*eslint-disable-next-line @typescript-eslint/no-explicit-any*/}
                {currentRecords?.map((signature: any) => (
                  <Tr key={signature?._id}>
                    <DateDiv>{new Date(signature?.signedAt).toLocaleString()}</DateDiv>
                    <Name>{signature?.user?.name}</Name>
                    <Duration>{durationInHrAndMin(signature?.duration)}</Duration>
                    <Session>{signature?.session}</Session>
                    <Room>{signature?.room?.name}</Room>
                    <Signature>
                      <SignatureImgWrap>
                        <img
                          width="90px"
                          height="90px"
                          src={signature?.imageUrl as string}
                          alt="signature"
                        />
                      </SignatureImgWrap>
                    </Signature>
                  </Tr>
                ))}
              </div>
            )}
          </Table>
        )}
      </TableWrap>
    </PageWrapper>
  );
};
